// frontend/src/routes/DoctorRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from '@dr.pogodin/react-helmet';
import DashboardLayout from '../components/layout/DashboardLayout';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import RoleBasedRoute from '../components/auth/RoleBasedRoute';

// Doctor Pages
import DoctorDashboard from '../pages/doctor/DoctorDashboard';
import ManageConsultations from '../pages/doctor/ManageConsultations';
import PatientRecords from '../pages/doctor/PatientRecords';
import Schedule from '../pages/doctor/Schedule';
import Earnings from '../pages/doctor/Earnings';
import DoctorProfile from '../pages/doctor/DoctorProfile';
import OnlineConsultation from '../pages/doctor/OnlineConsultation';
import WritePrescription from '../pages/doctor/WritePrescription';
import ManageSubscription from '../pages/doctor/ManageSubscription';
import ConsultationDetail from '../pages/doctor/ConsultationDetail' ;

const DoctorRoutes = () => {
  return (
    <ProtectedRoute>
      <RoleBasedRoute allowedRoles={['doctor']}>
        <Routes>
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={
              <>
                <Helmet>
                  <title>Doctor Dashboard - MediGo</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <DoctorDashboard />
              </>
            } />
            
            <Route path="consultations" element={
              <>
                <Helmet>
                  <title>Manage Consultations - MediGo Doctor Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <ManageConsultations />
              </>
            } />

            <Route path="consultations/:id" element={
              <>
                <Helmet>
                  <title>Consultation Details - MediGo Doctor Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <ConsultationDetail />
              </>
            } />
            
            <Route path="patients" element={
              <>
                <Helmet>
                  <title>Patient Records - MediGo Doctor Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <PatientRecords />
              </>
            } />
            
            <Route path="schedule" element={
              <>
                <Helmet>
                  <title>Schedule Management - MediGo Doctor Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <Schedule />
              </>
            } />
            
            <Route path="earnings" element={
              <>
                <Helmet>
                  <title>Earnings Report - MediGo Doctor Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <Earnings />
              </>
            } />
            
            <Route path="subscription" element={
              <>
                <Helmet>
                  <title>Manage Subscription - MediGo Doctor Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <ManageSubscription />
              </>
            } />
            
            <Route path="profile" element={
              <>
                <Helmet>
                  <title>Doctor Profile - MediGo</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <DoctorProfile />
              </>
            } />
            
            <Route path="consultation/:id" element={
              <>
                <Helmet>
                  <title>Online Consultation - MediGo Doctor Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <OnlineConsultation />
              </>
            } />
            
            <Route path="prescription/write" element={
              <>
                <Helmet>
                  <title>Write Prescription - MediGo Doctor Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <WritePrescription />
              </>
            } />
          </Route>
        </Routes>
      </RoleBasedRoute>
    </ProtectedRoute>
  );
};

export default DoctorRoutes;